import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

export default function TestLogin() {
  const navigate = useNavigate();

  const loginAsAdmin = () => {
    localStorage.setItem("session_token", "admin_token_1762451209783");
    window.location.href = "/";
  };

  const loginAsStudent = () => {
    localStorage.setItem("session_token", "student_token_1762460375989");
    window.location.href = "/";
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center p-6">
      <Card className="max-w-md w-full p-8 bg-white">
        <h1 className="text-3xl font-bold text-center mb-2 text-slate-800">Test Login</h1>
        <p className="text-center text-slate-600 mb-8">Choose your role to test the platform</p>
        
        <div className="space-y-4">
          <Button
            onClick={loginAsAdmin}
            className="w-full bg-indigo-600 hover:bg-indigo-700 h-14 text-lg"
          >
            🔧 Login as Admin
          </Button>
          
          <Button
            onClick={loginAsStudent}
            className="w-full bg-blue-600 hover:bg-blue-700 h-14 text-lg"
          >
            🎓 Login as Student
          </Button>
        </div>

        <div className="mt-8 p-4 bg-slate-50 rounded-lg text-sm text-slate-600">
          <p className="font-semibold mb-2">Quick Info:</p>
          <ul className="space-y-1 text-xs">
            <li>• <strong>Admin:</strong> Create/edit courses, manage sources, assessments</li>
            <li>• <strong>Student:</strong> View courses, ask AI questions, take assessments</li>
          </ul>
        </div>
      </Card>
    </div>
  );
}
